import React from "react";
import { Modal } from "react-bootstrap";

export default function Thankyou({ closeForm }) {
  return (
    <Modal.Body className="thankyou-slide height100">
      <div className="background-image"></div>
      <div className="wrapper">
        <h1>Thank you!</h1>
        <a className="mt20 btn btn-white btn-outline" onClick={closeForm}>
          Close
        </a>
      </div>
    </Modal.Body>
  );
}
